
<fieldset class="card card-block card-outline-secondary">
    <!--<legend>وقف تعامل مريض</legend>-->
    <div class="row">
        <div class="col-sm-12">
            <div class="form-group">
                <sanabel-selectize appcode="38" [(ngModel)] ="PatStopDeal.stopDealReson"  #selectize >
                </sanabel-selectize>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <div class="form-group">
                <label for="formGroupExampleInput"> {{'STARTSTOPDEAL' | translate}}</label>
                <div class="input-group input-group-sm">
                    <input class="form-control" placeholder="{{'DATEFORMAT' | translate}}"
                           name="startStopDealNgb"
                           [(ngModel)]="PatStopDeal.startStopDealNgb"
                           ngbDatepicker #startStopDeal="ngbDatepicker"
                           >
                    <div class="input-group-addon" (click)="startStopDeal.toggle()">
                        <i class="fa fa-calendar"></i>
                    </div>
                </div>
            
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <div class="form-group">
                <label for="formGroupExampleInput">{{'ENDSTOPDEAL' | translate}}</label>
                <div class="input-group input-group-sm">
                    <input class="form-control" placeholder="{{'DATEFORMAT' | translate}}"
                           name="endStopDealNgb"
                           (navigate)="ondateChange($event)"
                           [(ngModel)]="PatStopDeal.endStopDealNgb"
                           ngbDatepicker #endStopDeal="ngbDatepicker">
                    <div class="input-group-addon" (click)="endStopDeal.toggle()">
                        <i class="fa fa-calendar"></i>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <div class="form-group">
                <label for="comment"> {{'NOTES' | translate}}</label>
                <textarea class="form-control" rows="4" id="comment" [(ngModel)]="PatStopDeal.notes" name="notes"></textarea>
            </div>
        </div>
    </div>
    <button type="button" class="btn btn-success" (click)="addPatStopDeal()">
        {{'SAVE' | translate}}
    </button>
</fieldset>
